import { render, staticRenderFns } from "./UserManagmentOption.vue?vue&type=template&id=c96822d2"
import script from "./UserManagmentOption.vue?vue&type=script&lang=js"
export * from "./UserManagmentOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports